import { render, staticRenderFns } from "./TestPassageProcess.vue?vue&type=template&id=97f9c614&scoped=true&"
import script from "./TestPassageProcess.vue?vue&type=script&lang=js&"
export * from "./TestPassageProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f9c614",
  null
  
)

export default component.exports